import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";

const ClockIcon = ({ icon }) => (
    icon ? <img src={icon} alt="availability icon" /> : (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM17.25 12.75H12C11.8011 12.75 11.6103 12.671 11.4697 12.5303C11.329 12.3897 11.25 12.1989 11.25 12V6.75C11.25 6.55109 11.329 6.36032 11.4697 6.21967C11.6103 6.07902 11.8011 6 12 6C12.1989 6 12.3897 6.07902 12.5303 6.21967C12.671 6.36032 12.75 6.55109 12.75 6.75V11.25H17.25C17.4489 11.25 17.6397 11.329 17.7803 11.4697C17.921 11.6103 18 11.8011 18 12C18 12.1989 17.921 12.3897 17.7803 12.5303C17.6397 12.671 17.4489 12.75 17.25 12.75Z" fill="#0066CC"/>
        </svg>
    )
);

ClockIcon.propTypes = {
    icon: PropTypes.string
};

const ComingSoonAvailabilityCard = ({
    cmsSections = []
}) => {
    const availabilityCardSection = useMemo(
        () => getPageSectionByName(cmsSections, "COMING_SOON_AVAILABILITY_CARD"),
        [cmsSections]
    );
    const availabilityCardData = useMemo(
        () => availabilityCardSection?.meta?.data || {},
        [availabilityCardSection]
    );
    const title = availabilityCardData?.title || "This car will be available in next 5-7 days*";
    const subtitle = availabilityCardData?.subtitle || "Timelines may vary to ensure top quality standards";
    const icon = availabilityCardData?.icon || "";

    return (
        <div styleName={"styles.card"}>
            <div styleName={"styles.iconWrap"}>
                <ClockIcon icon={icon} />
            </div>
            <div styleName={"styles.content"}>
                <p styleName={"styles.title"}>{title}</p>
                <p styleName={"styles.subtitle"}>{subtitle}</p>
            </div>
        </div>
    );
};

ComingSoonAvailabilityCard.propTypes = {
    cmsSections: PropTypes.array
};

export default ComingSoonAvailabilityCard;
